import React, { useState } from 'react';
import { useTenantTerm } from '../../hooks/useTenantTerm';
import { Link } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import { History } from 'lucide-react';
import { Lease, formatInterval } from '../../types/leases';
import { formatCurrency } from '../../Helpers/FormatUtils';
import { coTenantEntries, leasesPath } from '../../Helpers/leaseUtils';
import { translate } from '../../types/EnumTranslations';
import './Leases.css';
import '../../Components/RentableDetail/RentableDetail.css';

interface LeaseHistoryButtonProps {
    buildingKey: string;
    /** The object's ended leases, newest first (`endedLeasesForObject`). */
    leases: Lease[];
    getTenantName: (tenantKey: string) => string;
}

/**
 * "Tidigare hyresgäster" in a parking spot, storage unit or unit's Hyresavtal
 * section (admins only): a link-style button opening the object's ended leases in a
 * modal. Each row opens the lease on the building's Avtal page.
 */
const LeaseHistoryButton: React.FC<LeaseHistoryButtonProps> = ({ buildingKey, leases, getTenantName }) => {
    const [show, setShow] = useState(false);
    const tenants = useTenantTerm().plural.toLowerCase();

    return (
        <>
            <button type="button" className="rentable-detail-link" onClick={() => setShow(true)}>
                <History size={14} />Tidigare {tenants}
            </button>
            <Modal show={show} onHide={() => setShow(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Tidigare {tenants}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {leases.length === 0 ? (
                        <p style={{ color: '#999', margin: 0 }}>Inga tidigare {tenants}</p>
                    ) : (
                        <ul className="lease-history-list">
                            {leases.map(lease => {
                                const names = [
                                    getTenantName(lease.tenantKey),
                                    ...coTenantEntries(lease).map(entry => `${getTenantName(entry.tenantKey)} (${translate(entry.role).toLowerCase()})`),
                                ].join(', ');
                                return (
                                    <li key={lease.key}>
                                        <Link to={leasesPath(buildingKey, lease.key)} className="lease-history-row">
                                            <span className="lease-history-names">{names}</span>
                                            <span className="text-muted">
                                                {lease.startDate} – {lease.endDate} · {formatCurrency(lease.amount)} {formatInterval(lease.interval)}
                                            </span>
                                        </Link>
                                    </li>
                                );
                            })}
                        </ul>
                    )}
                </Modal.Body>
            </Modal>
        </>
    );
};

export default LeaseHistoryButton;
